import { locationRunLabelBounds } from "../LocationLayout/bounds";
import type { BoardModelDebuggable } from "../../board/BoardModelDebug/debuggable";

export function locationRunPrimaryDebuggable(
  runId: string,
): BoardModelDebuggable {
  return {
    kind: "LocationPrimary",
    debugId: runId,
    measure: (context) =>
      locationRunLabelBounds(context.world, context.locationsRoot, runId),
  };
}

export function locationRunSecondaryDebuggable(
  runId: string,
): BoardModelDebuggable {
  return {
    kind: "LocationSecondary",
    debugId: runId,
    measure: (context) =>
      locationRunLabelBounds(context.world, context.locationsRoot, runId),
  };
}
